import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FieldsFormStateService {

    private state: Record<string, any> = {};

    setFormState(key: string, value: any): void {
        this.state[key] = value;
    }

    getFormState(key: string): any {
        return this.state[key];
    }
}
